// source: livongo/protobuf/grpc/external/education/education.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var livongo_protobuf_common_user_program_pb = require('../../../../../livongo/protobuf/common/user/program_pb.js');
goog.object.extend(proto, livongo_protobuf_common_user_program_pb);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.Answer', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.ContentStatus', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.ContentStatus.Values', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.CourseSummary', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.CourseUserData', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.FilterCase', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.FilterCase', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.FilterCase', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.FilterCase', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.ImageField', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.ImageType', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.ImageType.Values', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.Lesson', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.LessonRow', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.LessonUserData', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.Page', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.PageType', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.PageType.Values', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.PageUserData', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.ServiceInfo', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.SupportLinks', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.Term', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.TextField', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.TextType', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.TextType.Values', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.CriteriaCase', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.UserAnswers', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.UserInfo', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse.displayName = 'proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.displayName = 'proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.UserInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.UserInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.UserInfo.displayName = 'proto.com.livongo.protobuf.grpc.external.education.UserInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.ServiceInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.ServiceInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.ServiceInfo.displayName = 'proto.com.livongo.protobuf.grpc.external.education.ServiceInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.oneofGroups_);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2.displayName = 'proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields.displayName = 'proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.oneofGroups_);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields.displayName = 'proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.CourseSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.education.CourseSummary.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.CourseSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.CourseSummary.displayName = 'proto.com.livongo.protobuf.grpc.external.education.CourseSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.LessonRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.LessonRow.displayName = 'proto.com.livongo.protobuf.grpc.external.education.LessonRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.CourseUserData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.CourseUserData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.CourseUserData.displayName = 'proto.com.livongo.protobuf.grpc.external.education.CourseUserData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.oneofGroups_);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.Lesson = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.education.Lesson.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.Lesson, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.Lesson.displayName = 'proto.com.livongo.protobuf.grpc.external.education.Lesson';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.Page = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.education.Page.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.Page, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.Page.displayName = 'proto.com.livongo.protobuf.grpc.external.education.Page';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.Answer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.Answer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.Answer.displayName = 'proto.com.livongo.protobuf.grpc.external.education.Answer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.UserAnswers = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.education.UserAnswers.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.UserAnswers, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.UserAnswers.displayName = 'proto.com.livongo.protobuf.grpc.external.education.UserAnswers';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.oneofGroups_);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields.displayName = 'proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields.displayName = 'proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.TextField = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.TextField, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.TextField.displayName = 'proto.com.livongo.protobuf.grpc.external.education.TextField';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.ImageField = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.ImageField, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.ImageField.displayName = 'proto.com.livongo.protobuf.grpc.external.education.ImageField';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.Term = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.Term, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.Term.displayName = 'proto.com.livongo.protobuf.grpc.external.education.Term';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.LessonUserData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.LessonUserData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.LessonUserData.displayName = 'proto.com.livongo.protobuf.grpc.external.education.LessonUserData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.PageUserData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.PageUserData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.PageUserData.displayName = 'proto.com.livongo.protobuf.grpc.external.education.PageUserData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.oneofGroups_);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.SupportLinks = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.SupportLinks, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.SupportLinks.displayName = 'proto.com.livongo.protobuf.grpc.external.education.SupportLinks';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.ContentStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.ContentStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.ContentStatus.displayName = 'proto.com.livongo.protobuf.grpc.external.education.ContentStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.PageType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.PageType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.PageType.displayName = 'proto.com.livongo.protobuf.grpc.external.education.PageType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.ImageType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.ImageType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.ImageType.displayName = 'proto.com.livongo.protobuf.grpc.external.education.ImageType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.education.TextType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.education.TextType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.education.TextType.displayName = 'proto.com.livongo.protobuf.grpc.external.education.TextType';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    videoId: (f = msg.getVideoId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    videoName: (f = msg.getVideoName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest}
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest;
  return proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest}
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setVideoId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setVideoName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVideoId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getVideoName();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Int32Value video_id = 1;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest.prototype.getVideoId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 1));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest.prototype.setVideoId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest.prototype.clearVideoId = function() {
  return this.setVideoId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest.prototype.hasVideoId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue video_name = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest.prototype.getVideoName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest.prototype.setVideoName = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest.prototype.clearVideoName = function() {
  return this.setVideoName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusRequest.prototype.hasVideoName = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    videoStatusList: jspb.Message.toObjectList(msg.getVideoStatusList(),
    proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse}
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse;
  return proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse}
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.deserializeBinaryFromReader);
      msg.addVideoStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVideoStatusList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UserVideoStatus video_status = 1;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus>}
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse.prototype.getVideoStatusList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus, 1));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse.prototype.setVideoStatusList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus}
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse.prototype.addVideoStatus = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.GetVideoStatusResponse.prototype.clearVideoStatusList = function() {
  return this.setVideoStatusList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    videoId: (f = msg.getVideoId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    videoName: (f = msg.getVideoName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    watched: (f = msg.getWatched()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus}
 */
proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus;
  return proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus}
 */
proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setVideoId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setVideoName(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setWatched(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVideoId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getVideoName();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getWatched();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Int32Value video_id = 1;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.prototype.getVideoId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 1));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.prototype.setVideoId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.prototype.clearVideoId = function() {
  return this.setVideoId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.prototype.hasVideoId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue video_name = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.prototype.getVideoName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.prototype.setVideoName = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.prototype.clearVideoName = function() {
  return this.setVideoName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.prototype.hasVideoName = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.BoolValue watched = 3;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.prototype.getWatched = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 3));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.prototype.setWatched = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.prototype.clearWatched = function() {
  return this.setWatched(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.UserVideoStatus.prototype.hasWatched = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.UserInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.UserInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.UserInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.UserInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    userUuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UserInfo}
 */
proto.com.livongo.protobuf.grpc.external.education.UserInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.UserInfo;
  return proto.com.livongo.protobuf.grpc.external.education.UserInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.UserInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UserInfo}
 */
proto.com.livongo.protobuf.grpc.external.education.UserInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.UserInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.UserInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.UserInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.UserInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_uuid = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.education.UserInfo.prototype.getUserUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UserInfo} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.UserInfo.prototype.setUserUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.ServiceInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.ServiceInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.ServiceInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.ServiceInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    webUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    dppIntroWebUrl: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ServiceInfo}
 */
proto.com.livongo.protobuf.grpc.external.education.ServiceInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.ServiceInfo;
  return proto.com.livongo.protobuf.grpc.external.education.ServiceInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.ServiceInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ServiceInfo}
 */
proto.com.livongo.protobuf.grpc.external.education.ServiceInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDppIntroWebUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.ServiceInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.ServiceInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.ServiceInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.ServiceInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWebUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDppIntroWebUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string web_url = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.education.ServiceInfo.prototype.getWebUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ServiceInfo} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.ServiceInfo.prototype.setWebUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string dpp_intro_web_url = 2;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.education.ServiceInfo.prototype.getDppIntroWebUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ServiceInfo} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.ServiceInfo.prototype.setDppIntroWebUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.FilterCase = {
  FILTER_NOT_SET: 0,
  PROGRAM: 1
};

/**
 * @return {proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.FilterCase}
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.prototype.getFilterCase = function() {
  return /** @type {proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.FilterCase} */(jspb.Message.computeOneofCase(this, proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    program: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest}
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest;
  return proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest}
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.livongo.protobuf.common.user.program.Program.Values} */ (reader.readEnum());
      msg.setProgram(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.com.livongo.protobuf.common.user.program.Program.Values} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional com.livongo.protobuf.common.user.program.Program.Values program = 1;
 * @return {!proto.com.livongo.protobuf.common.user.program.Program.Values}
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.prototype.getProgram = function() {
  return /** @type {!proto.com.livongo.protobuf.common.user.program.Program.Values} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.common.user.program.Program.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.prototype.setProgram = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.prototype.clearProgram = function() {
  return jspb.Message.setOneofField(this, 1, proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationServiceInfoRequest.prototype.hasProgram = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2.toObject = function(includeInstance, msg) {
  var f, obj = {
    webUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    introWebUrl: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2}
 */
proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2;
  return proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2}
 */
proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIntroWebUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWebUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIntroWebUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string web_url = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2.prototype.getWebUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2.prototype.setWebUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string intro_web_url = 2;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2.prototype.getIntroWebUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.ServiceInfo2.prototype.setIntroWebUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    curriculumId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    timeZone: (f = msg.getTimeZone()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    tzOffset: (f = msg.getTzOffset()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    testOnlyFields: (f = msg.getTestOnlyFields()) && proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest}
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest;
  return proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest}
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurriculumId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTimeZone(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setTzOffset(value);
      break;
    case 100:
      var value = new proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields.deserializeBinaryFromReader);
      msg.setTestOnlyFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurriculumId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTimeZone();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTzOffset();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getTestOnlyFields();
  if (f != null) {
    writer.writeMessage(
      100,
      f,
      proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields.toObject = function(includeInstance, msg) {
  var f, obj = {
    timestamp: (f = msg.getTimestamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields;
  return proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimestamp();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp timestamp = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields.prototype.getTimestamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields.prototype.setTimestamp = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields.prototype.clearTimestamp = function() {
  return this.setTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 curriculum_id = 1;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.prototype.getCurriculumId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.prototype.setCurriculumId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue time_zone = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.prototype.getTimeZone = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.prototype.setTimeZone = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.prototype.clearTimeZone = function() {
  return this.setTimeZone(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.prototype.hasTimeZone = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Int32Value tz_offset = 3;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.prototype.getTzOffset = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 3));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.prototype.setTzOffset = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.prototype.clearTzOffset = function() {
  return this.setTzOffset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.prototype.hasTzOffset = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional TestOnlyFields test_only_fields = 100;
 * @return {?proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.prototype.getTestOnlyFields = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields, 100));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.TestOnlyFields|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.prototype.setTestOnlyFields = function(value) {
  return jspb.Message.setWrapperField(this, 100, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.prototype.clearTestOnlyFields = function() {
  return this.setTestOnlyFields(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.GetCourseSummaryRequest.prototype.hasTestOnlyFields = function() {
  return jspb.Message.getField(this, 100) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.FilterCase = {
  FILTER_NOT_SET: 0,
  PROGRAM: 1
};

/**
 * @return {proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.FilterCase}
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.prototype.getFilterCase = function() {
  return /** @type {proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.FilterCase} */(jspb.Message.computeOneofCase(this, proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    program: jspb.Message.getFieldWithDefault(msg, 1, 0),
    timeZone: (f = msg.getTimeZone()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    tzOffset: (f = msg.getTzOffset()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    testOnlyFields: (f = msg.getTestOnlyFields()) && proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest}
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest;
  return proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest}
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.livongo.protobuf.common.user.program.Program.Values} */ (reader.readEnum());
      msg.setProgram(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTimeZone(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setTzOffset(value);
      break;
    case 100:
      var value = new proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields.deserializeBinaryFromReader);
      msg.setTestOnlyFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.com.livongo.protobuf.common.user.program.Program.Values} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTimeZone();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTzOffset();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getTestOnlyFields();
  if (f != null) {
    writer.writeMessage(
      100,
      f,
      proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields.toObject = function(includeInstance, msg) {
  var f, obj = {
    timestamp: (f = msg.getTimestamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields;
  return proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimestamp();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp timestamp = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields.prototype.getTimestamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields.prototype.setTimestamp = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields.prototype.clearTimestamp = function() {
  return this.setTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional com.livongo.protobuf.common.user.program.Program.Values program = 1;
 * @return {!proto.com.livongo.protobuf.common.user.program.Program.Values}
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.prototype.getProgram = function() {
  return /** @type {!proto.com.livongo.protobuf.common.user.program.Program.Values} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.common.user.program.Program.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.prototype.setProgram = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.prototype.clearProgram = function() {
  return jspb.Message.setOneofField(this, 1, proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.prototype.hasProgram = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue time_zone = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.prototype.getTimeZone = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.prototype.setTimeZone = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.prototype.clearTimeZone = function() {
  return this.setTimeZone(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.prototype.hasTimeZone = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Int32Value tz_offset = 3;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.prototype.getTzOffset = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 3));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.prototype.setTzOffset = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.prototype.clearTzOffset = function() {
  return this.setTzOffset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.prototype.hasTzOffset = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional TestOnlyFields test_only_fields = 100;
 * @return {?proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.prototype.getTestOnlyFields = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields, 100));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.TestOnlyFields|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.prototype.setTestOnlyFields = function(value) {
  return jspb.Message.setWrapperField(this, 100, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.prototype.clearTestOnlyFields = function() {
  return this.setTestOnlyFields(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.GetDesiredCourseSummaryRequest.prototype.hasTestOnlyFields = function() {
  return jspb.Message.getField(this, 100) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.education.CourseSummary.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.CourseSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.CourseSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.CourseSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.CourseSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    textFieldsMap: (f = msg.getTextFieldsMap()) ? f.toObject(includeInstance, proto.com.livongo.protobuf.grpc.external.education.TextField.toObject) : [],
    imageFieldsMap: (f = msg.getImageFieldsMap()) ? f.toObject(includeInstance, proto.com.livongo.protobuf.grpc.external.education.ImageField.toObject) : [],
    lessonInfosList: jspb.Message.toObjectList(msg.getLessonInfosList(),
    proto.com.livongo.protobuf.grpc.external.education.LessonRow.toObject, includeInstance),
    courseUserData: (f = msg.getCourseUserData()) && proto.com.livongo.protobuf.grpc.external.education.CourseUserData.toObject(includeInstance, f),
    curriculumPartNumber: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.CourseSummary}
 */
proto.com.livongo.protobuf.grpc.external.education.CourseSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.CourseSummary;
  return proto.com.livongo.protobuf.grpc.external.education.CourseSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.CourseSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.CourseSummary}
 */
proto.com.livongo.protobuf.grpc.external.education.CourseSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getTextFieldsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.com.livongo.protobuf.grpc.external.education.TextField.deserializeBinaryFromReader, "", new proto.com.livongo.protobuf.grpc.external.education.TextField());
         });
      break;
    case 2:
      var value = msg.getImageFieldsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.com.livongo.protobuf.grpc.external.education.ImageField.deserializeBinaryFromReader, "", new proto.com.livongo.protobuf.grpc.external.education.ImageField());
         });
      break;
    case 3:
      var value = new proto.com.livongo.protobuf.grpc.external.education.LessonRow;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.education.LessonRow.deserializeBinaryFromReader);
      msg.addLessonInfos(value);
      break;
    case 4:
      var value = new proto.com.livongo.protobuf.grpc.external.education.CourseUserData;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.education.CourseUserData.deserializeBinaryFromReader);
      msg.setCourseUserData(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurriculumPartNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.CourseSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.CourseSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.CourseSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.CourseSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTextFieldsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.com.livongo.protobuf.grpc.external.education.TextField.serializeBinaryToWriter);
  }
  f = message.getImageFieldsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.com.livongo.protobuf.grpc.external.education.ImageField.serializeBinaryToWriter);
  }
  f = message.getLessonInfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.com.livongo.protobuf.grpc.external.education.LessonRow.serializeBinaryToWriter
    );
  }
  f = message.getCourseUserData();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.com.livongo.protobuf.grpc.external.education.CourseUserData.serializeBinaryToWriter
    );
  }
  f = message.getCurriculumPartNumber();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * map<string, TextField> text_fields = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.com.livongo.protobuf.grpc.external.education.TextField>}
 */
proto.com.livongo.protobuf.grpc.external.education.CourseSummary.prototype.getTextFieldsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.com.livongo.protobuf.grpc.external.education.TextField>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.com.livongo.protobuf.grpc.external.education.TextField));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.CourseSummary} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.CourseSummary.prototype.clearTextFieldsMap = function() {
  this.getTextFieldsMap().clear();
  return this;
};


/**
 * map<string, ImageField> image_fields = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.com.livongo.protobuf.grpc.external.education.ImageField>}
 */
proto.com.livongo.protobuf.grpc.external.education.CourseSummary.prototype.getImageFieldsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.com.livongo.protobuf.grpc.external.education.ImageField>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      proto.com.livongo.protobuf.grpc.external.education.ImageField));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.CourseSummary} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.CourseSummary.prototype.clearImageFieldsMap = function() {
  this.getImageFieldsMap().clear();
  return this;
};


/**
 * repeated LessonRow lesson_infos = 3;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.education.LessonRow>}
 */
proto.com.livongo.protobuf.grpc.external.education.CourseSummary.prototype.getLessonInfosList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.education.LessonRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.education.LessonRow, 3));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.education.LessonRow>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.CourseSummary} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.CourseSummary.prototype.setLessonInfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.education.LessonRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.education.LessonRow}
 */
proto.com.livongo.protobuf.grpc.external.education.CourseSummary.prototype.addLessonInfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.com.livongo.protobuf.grpc.external.education.LessonRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.CourseSummary} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.CourseSummary.prototype.clearLessonInfosList = function() {
  return this.setLessonInfosList([]);
};


/**
 * optional CourseUserData course_user_data = 4;
 * @return {?proto.com.livongo.protobuf.grpc.external.education.CourseUserData}
 */
proto.com.livongo.protobuf.grpc.external.education.CourseSummary.prototype.getCourseUserData = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.education.CourseUserData} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.education.CourseUserData, 4));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.education.CourseUserData|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.CourseSummary} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.CourseSummary.prototype.setCourseUserData = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.CourseSummary} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.CourseSummary.prototype.clearCourseUserData = function() {
  return this.setCourseUserData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.CourseSummary.prototype.hasCourseUserData = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string curriculum_part_number = 5;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.education.CourseSummary.prototype.getCurriculumPartNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.CourseSummary} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.CourseSummary.prototype.setCurriculumPartNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.LessonRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.LessonRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.toObject = function(includeInstance, msg) {
  var f, obj = {
    lessonId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    lessonNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    availableAt: (f = msg.getAvailableAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    textFieldsMap: (f = msg.getTextFieldsMap()) ? f.toObject(includeInstance, proto.com.livongo.protobuf.grpc.external.education.TextField.toObject) : [],
    imageFieldsMap: (f = msg.getImageFieldsMap()) ? f.toObject(includeInstance, proto.com.livongo.protobuf.grpc.external.education.ImageField.toObject) : [],
    uiAvailableAt: (f = msg.getUiAvailableAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    systemAvailableAt: (f = msg.getSystemAvailableAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    completedAt: (f = msg.getCompletedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.LessonRow}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.LessonRow;
  return proto.com.livongo.protobuf.grpc.external.education.LessonRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.LessonRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.LessonRow}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLessonId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLessonNumber(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setAvailableAt(value);
      break;
    case 4:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.education.ContentStatus.Values} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = msg.getTextFieldsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.com.livongo.protobuf.grpc.external.education.TextField.deserializeBinaryFromReader, "", new proto.com.livongo.protobuf.grpc.external.education.TextField());
         });
      break;
    case 6:
      var value = msg.getImageFieldsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.com.livongo.protobuf.grpc.external.education.ImageField.deserializeBinaryFromReader, "", new proto.com.livongo.protobuf.grpc.external.education.ImageField());
         });
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUiAvailableAt(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSystemAvailableAt(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCompletedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.LessonRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.LessonRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLessonId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLessonNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAvailableAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getTextFieldsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.com.livongo.protobuf.grpc.external.education.TextField.serializeBinaryToWriter);
  }
  f = message.getImageFieldsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.com.livongo.protobuf.grpc.external.education.ImageField.serializeBinaryToWriter);
  }
  f = message.getUiAvailableAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSystemAvailableAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCompletedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 lesson_id = 1;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.getLessonId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.LessonRow} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.setLessonId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 lesson_number = 2;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.getLessonNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.LessonRow} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.setLessonNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp available_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.getAvailableAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.LessonRow} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.setAvailableAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.LessonRow} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.clearAvailableAt = function() {
  return this.setAvailableAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.hasAvailableAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ContentStatus.Values status = 4;
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ContentStatus.Values}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.getStatus = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.education.ContentStatus.Values} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.education.ContentStatus.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.LessonRow} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * map<string, TextField> text_fields = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.com.livongo.protobuf.grpc.external.education.TextField>}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.getTextFieldsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.com.livongo.protobuf.grpc.external.education.TextField>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      proto.com.livongo.protobuf.grpc.external.education.TextField));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.LessonRow} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.clearTextFieldsMap = function() {
  this.getTextFieldsMap().clear();
  return this;
};


/**
 * map<string, ImageField> image_fields = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.com.livongo.protobuf.grpc.external.education.ImageField>}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.getImageFieldsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.com.livongo.protobuf.grpc.external.education.ImageField>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      proto.com.livongo.protobuf.grpc.external.education.ImageField));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.LessonRow} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.clearImageFieldsMap = function() {
  this.getImageFieldsMap().clear();
  return this;
};


/**
 * optional google.protobuf.Timestamp ui_available_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.getUiAvailableAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.LessonRow} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.setUiAvailableAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.LessonRow} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.clearUiAvailableAt = function() {
  return this.setUiAvailableAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.hasUiAvailableAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp system_available_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.getSystemAvailableAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.LessonRow} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.setSystemAvailableAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.LessonRow} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.clearSystemAvailableAt = function() {
  return this.setSystemAvailableAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.hasSystemAvailableAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp completed_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.getCompletedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.LessonRow} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.setCompletedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.LessonRow} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.clearCompletedAt = function() {
  return this.setCompletedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonRow.prototype.hasCompletedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.CourseUserData.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.CourseUserData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.CourseUserData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.CourseUserData.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    courseId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    resumeLessonId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    canStartLesson: (f = msg.getCanStartLesson()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.CourseUserData}
 */
proto.com.livongo.protobuf.grpc.external.education.CourseUserData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.CourseUserData;
  return proto.com.livongo.protobuf.grpc.external.education.CourseUserData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.CourseUserData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.CourseUserData}
 */
proto.com.livongo.protobuf.grpc.external.education.CourseUserData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.education.ContentStatus.Values} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCourseId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setResumeLessonId(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCanStartLesson(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.CourseUserData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.CourseUserData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.CourseUserData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.CourseUserData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getCourseId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getResumeLessonId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCanStartLesson();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional ContentStatus.Values status = 1;
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ContentStatus.Values}
 */
proto.com.livongo.protobuf.grpc.external.education.CourseUserData.prototype.getStatus = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.education.ContentStatus.Values} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.education.ContentStatus.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.CourseUserData} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.CourseUserData.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 course_id = 2;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.education.CourseUserData.prototype.getCourseId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.CourseUserData} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.CourseUserData.prototype.setCourseId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 resume_lesson_id = 3;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.education.CourseUserData.prototype.getResumeLessonId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.CourseUserData} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.CourseUserData.prototype.setResumeLessonId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.protobuf.BoolValue can_start_lesson = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.com.livongo.protobuf.grpc.external.education.CourseUserData.prototype.getCanStartLesson = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.CourseUserData} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.CourseUserData.prototype.setCanStartLesson = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.CourseUserData} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.CourseUserData.prototype.clearCanStartLesson = function() {
  return this.setCanStartLesson(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.CourseUserData.prototype.hasCanStartLesson = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.oneofGroups_ = [[3]];

/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.FilterCase = {
  FILTER_NOT_SET: 0,
  PROGRAM: 3
};

/**
 * @return {proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.FilterCase}
 */
proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.prototype.getFilterCase = function() {
  return /** @type {proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.FilterCase} */(jspb.Message.computeOneofCase(this, proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    courseId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    lessonId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    program: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest}
 */
proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest;
  return proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest}
 */
proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCourseId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLessonId(value);
      break;
    case 3:
      var value = /** @type {!proto.com.livongo.protobuf.common.user.program.Program.Values} */ (reader.readEnum());
      msg.setProgram(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCourseId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLessonId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {!proto.com.livongo.protobuf.common.user.program.Program.Values} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional int32 course_id = 1;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.prototype.getCourseId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.prototype.setCourseId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 lesson_id = 2;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.prototype.getLessonId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.prototype.setLessonId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional com.livongo.protobuf.common.user.program.Program.Values program = 3;
 * @return {!proto.com.livongo.protobuf.common.user.program.Program.Values}
 */
proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.prototype.getProgram = function() {
  return /** @type {!proto.com.livongo.protobuf.common.user.program.Program.Values} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.common.user.program.Program.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.prototype.setProgram = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.prototype.clearProgram = function() {
  return jspb.Message.setOneofField(this, 3, proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.GetLessonRequest.prototype.hasProgram = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.education.Lesson.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.Lesson.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.Lesson.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.Lesson} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.Lesson.toObject = function(includeInstance, msg) {
  var f, obj = {
    textFieldsMap: (f = msg.getTextFieldsMap()) ? f.toObject(includeInstance, proto.com.livongo.protobuf.grpc.external.education.TextField.toObject) : [],
    imageFieldsMap: (f = msg.getImageFieldsMap()) ? f.toObject(includeInstance, proto.com.livongo.protobuf.grpc.external.education.ImageField.toObject) : [],
    pagesList: jspb.Message.toObjectList(msg.getPagesList(),
    proto.com.livongo.protobuf.grpc.external.education.Page.toObject, includeInstance),
    lessonUserData: (f = msg.getLessonUserData()) && proto.com.livongo.protobuf.grpc.external.education.LessonUserData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Lesson}
 */
proto.com.livongo.protobuf.grpc.external.education.Lesson.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.Lesson;
  return proto.com.livongo.protobuf.grpc.external.education.Lesson.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.Lesson} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Lesson}
 */
proto.com.livongo.protobuf.grpc.external.education.Lesson.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getTextFieldsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.com.livongo.protobuf.grpc.external.education.TextField.deserializeBinaryFromReader, "", new proto.com.livongo.protobuf.grpc.external.education.TextField());
         });
      break;
    case 2:
      var value = msg.getImageFieldsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.com.livongo.protobuf.grpc.external.education.ImageField.deserializeBinaryFromReader, "", new proto.com.livongo.protobuf.grpc.external.education.ImageField());
         });
      break;
    case 3:
      var value = new proto.com.livongo.protobuf.grpc.external.education.Page;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.education.Page.deserializeBinaryFromReader);
      msg.addPages(value);
      break;
    case 4:
      var value = new proto.com.livongo.protobuf.grpc.external.education.LessonUserData;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.education.LessonUserData.deserializeBinaryFromReader);
      msg.setLessonUserData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.Lesson.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.Lesson.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.Lesson} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.Lesson.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTextFieldsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.com.livongo.protobuf.grpc.external.education.TextField.serializeBinaryToWriter);
  }
  f = message.getImageFieldsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.com.livongo.protobuf.grpc.external.education.ImageField.serializeBinaryToWriter);
  }
  f = message.getPagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.com.livongo.protobuf.grpc.external.education.Page.serializeBinaryToWriter
    );
  }
  f = message.getLessonUserData();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.com.livongo.protobuf.grpc.external.education.LessonUserData.serializeBinaryToWriter
    );
  }
};


/**
 * map<string, TextField> text_fields = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.com.livongo.protobuf.grpc.external.education.TextField>}
 */
proto.com.livongo.protobuf.grpc.external.education.Lesson.prototype.getTextFieldsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.com.livongo.protobuf.grpc.external.education.TextField>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.com.livongo.protobuf.grpc.external.education.TextField));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Lesson} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.Lesson.prototype.clearTextFieldsMap = function() {
  this.getTextFieldsMap().clear();
  return this;
};


/**
 * map<string, ImageField> image_fields = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.com.livongo.protobuf.grpc.external.education.ImageField>}
 */
proto.com.livongo.protobuf.grpc.external.education.Lesson.prototype.getImageFieldsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.com.livongo.protobuf.grpc.external.education.ImageField>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      proto.com.livongo.protobuf.grpc.external.education.ImageField));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Lesson} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.Lesson.prototype.clearImageFieldsMap = function() {
  this.getImageFieldsMap().clear();
  return this;
};


/**
 * repeated Page pages = 3;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.education.Page>}
 */
proto.com.livongo.protobuf.grpc.external.education.Lesson.prototype.getPagesList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.education.Page>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.education.Page, 3));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.education.Page>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Lesson} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.Lesson.prototype.setPagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.education.Page=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Page}
 */
proto.com.livongo.protobuf.grpc.external.education.Lesson.prototype.addPages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.com.livongo.protobuf.grpc.external.education.Page, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Lesson} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.Lesson.prototype.clearPagesList = function() {
  return this.setPagesList([]);
};


/**
 * optional LessonUserData lesson_user_data = 4;
 * @return {?proto.com.livongo.protobuf.grpc.external.education.LessonUserData}
 */
proto.com.livongo.protobuf.grpc.external.education.Lesson.prototype.getLessonUserData = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.education.LessonUserData} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.education.LessonUserData, 4));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.education.LessonUserData|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Lesson} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.Lesson.prototype.setLessonUserData = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Lesson} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.Lesson.prototype.clearLessonUserData = function() {
  return this.setLessonUserData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.Lesson.prototype.hasLessonUserData = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.education.Page.repeatedFields_ = [6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.Page.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.Page.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.Page} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.Page.toObject = function(includeInstance, msg) {
  var f, obj = {
    pageId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    textFieldsMap: (f = msg.getTextFieldsMap()) ? f.toObject(includeInstance, proto.com.livongo.protobuf.grpc.external.education.TextField.toObject) : [],
    imageFieldsMap: (f = msg.getImageFieldsMap()) ? f.toObject(includeInstance, proto.com.livongo.protobuf.grpc.external.education.ImageField.toObject) : [],
    answersList: jspb.Message.toObjectList(msg.getAnswersList(),
    proto.com.livongo.protobuf.grpc.external.education.Answer.toObject, includeInstance),
    termsList: jspb.Message.toObjectList(msg.getTermsList(),
    proto.com.livongo.protobuf.grpc.external.education.Term.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Page}
 */
proto.com.livongo.protobuf.grpc.external.education.Page.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.Page;
  return proto.com.livongo.protobuf.grpc.external.education.Page.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.Page} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Page}
 */
proto.com.livongo.protobuf.grpc.external.education.Page.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.education.PageType.Values} */ (reader.readEnum());
      msg.setPageType(value);
      break;
    case 4:
      var value = msg.getTextFieldsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.com.livongo.protobuf.grpc.external.education.TextField.deserializeBinaryFromReader, "", new proto.com.livongo.protobuf.grpc.external.education.TextField());
         });
      break;
    case 5:
      var value = msg.getImageFieldsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.com.livongo.protobuf.grpc.external.education.ImageField.deserializeBinaryFromReader, "", new proto.com.livongo.protobuf.grpc.external.education.ImageField());
         });
      break;
    case 6:
      var value = new proto.com.livongo.protobuf.grpc.external.education.Answer;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.education.Answer.deserializeBinaryFromReader);
      msg.addAnswers(value);
      break;
    case 7:
      var value = new proto.com.livongo.protobuf.grpc.external.education.Term;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.education.Term.deserializeBinaryFromReader);
      msg.addTerms(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.Page.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.Page.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.Page} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.Page.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getTextFieldsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.com.livongo.protobuf.grpc.external.education.TextField.serializeBinaryToWriter);
  }
  f = message.getImageFieldsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.com.livongo.protobuf.grpc.external.education.ImageField.serializeBinaryToWriter);
  }
  f = message.getAnswersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.com.livongo.protobuf.grpc.external.education.Answer.serializeBinaryToWriter
    );
  }
  f = message.getTermsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.com.livongo.protobuf.grpc.external.education.Term.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 page_id = 1;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.education.Page.prototype.getPageId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Page} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.Page.prototype.setPageId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.education.Page.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Page} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.Page.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional PageType.Values page_type = 3;
 * @return {!proto.com.livongo.protobuf.grpc.external.education.PageType.Values}
 */
proto.com.livongo.protobuf.grpc.external.education.Page.prototype.getPageType = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.education.PageType.Values} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.education.PageType.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Page} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.Page.prototype.setPageType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * map<string, TextField> text_fields = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.com.livongo.protobuf.grpc.external.education.TextField>}
 */
proto.com.livongo.protobuf.grpc.external.education.Page.prototype.getTextFieldsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.com.livongo.protobuf.grpc.external.education.TextField>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      proto.com.livongo.protobuf.grpc.external.education.TextField));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Page} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.Page.prototype.clearTextFieldsMap = function() {
  this.getTextFieldsMap().clear();
  return this;
};


/**
 * map<string, ImageField> image_fields = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.com.livongo.protobuf.grpc.external.education.ImageField>}
 */
proto.com.livongo.protobuf.grpc.external.education.Page.prototype.getImageFieldsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.com.livongo.protobuf.grpc.external.education.ImageField>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      proto.com.livongo.protobuf.grpc.external.education.ImageField));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Page} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.Page.prototype.clearImageFieldsMap = function() {
  this.getImageFieldsMap().clear();
  return this;
};


/**
 * repeated Answer answers = 6;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.education.Answer>}
 */
proto.com.livongo.protobuf.grpc.external.education.Page.prototype.getAnswersList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.education.Answer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.education.Answer, 6));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.education.Answer>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Page} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.Page.prototype.setAnswersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.education.Answer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Answer}
 */
proto.com.livongo.protobuf.grpc.external.education.Page.prototype.addAnswers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.com.livongo.protobuf.grpc.external.education.Answer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Page} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.Page.prototype.clearAnswersList = function() {
  return this.setAnswersList([]);
};


/**
 * repeated Term terms = 7;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.education.Term>}
 */
proto.com.livongo.protobuf.grpc.external.education.Page.prototype.getTermsList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.education.Term>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.education.Term, 7));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.education.Term>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Page} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.Page.prototype.setTermsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.education.Term=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Term}
 */
proto.com.livongo.protobuf.grpc.external.education.Page.prototype.addTerms = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.com.livongo.protobuf.grpc.external.education.Term, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Page} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.Page.prototype.clearTermsList = function() {
  return this.setTermsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.Answer.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.Answer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.Answer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.Answer.toObject = function(includeInstance, msg) {
  var f, obj = {
    answerCmsId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    answerText: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isCorrect: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Answer}
 */
proto.com.livongo.protobuf.grpc.external.education.Answer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.Answer;
  return proto.com.livongo.protobuf.grpc.external.education.Answer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.Answer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Answer}
 */
proto.com.livongo.protobuf.grpc.external.education.Answer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswerCmsId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswerText(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCorrect(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.Answer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.Answer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.Answer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.Answer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnswerCmsId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAnswerText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsCorrect();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string answer_cms_id = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.education.Answer.prototype.getAnswerCmsId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Answer} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.Answer.prototype.setAnswerCmsId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string answer_text = 2;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.education.Answer.prototype.getAnswerText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Answer} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.Answer.prototype.setAnswerText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is_correct = 3;
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.Answer.prototype.getIsCorrect = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Answer} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.Answer.prototype.setIsCorrect = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.education.UserAnswers.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.UserAnswers.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.UserAnswers.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.UserAnswers} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.UserAnswers.toObject = function(includeInstance, msg) {
  var f, obj = {
    selectedAnswerCmsIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    selectedOtherAnswerText: (f = msg.getSelectedOtherAnswerText()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UserAnswers}
 */
proto.com.livongo.protobuf.grpc.external.education.UserAnswers.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.UserAnswers;
  return proto.com.livongo.protobuf.grpc.external.education.UserAnswers.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.UserAnswers} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UserAnswers}
 */
proto.com.livongo.protobuf.grpc.external.education.UserAnswers.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addSelectedAnswerCmsIds(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSelectedOtherAnswerText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.UserAnswers.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.UserAnswers.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.UserAnswers} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.UserAnswers.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSelectedAnswerCmsIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getSelectedOtherAnswerText();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * repeated string selected_answer_cms_ids = 1;
 * @return {!Array<string>}
 */
proto.com.livongo.protobuf.grpc.external.education.UserAnswers.prototype.getSelectedAnswerCmsIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UserAnswers} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.UserAnswers.prototype.setSelectedAnswerCmsIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UserAnswers} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.UserAnswers.prototype.addSelectedAnswerCmsIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UserAnswers} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.UserAnswers.prototype.clearSelectedAnswerCmsIdsList = function() {
  return this.setSelectedAnswerCmsIdsList([]);
};


/**
 * optional google.protobuf.StringValue selected_other_answer_text = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.com.livongo.protobuf.grpc.external.education.UserAnswers.prototype.getSelectedOtherAnswerText = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UserAnswers} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.UserAnswers.prototype.setSelectedOtherAnswerText = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UserAnswers} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.UserAnswers.prototype.clearSelectedOtherAnswerText = function() {
  return this.setSelectedOtherAnswerText(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.UserAnswers.prototype.hasSelectedOtherAnswerText = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.oneofGroups_ = [[3]];

/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.CriteriaCase = {
  CRITERIA_NOT_SET: 0,
  PROGRAM: 3
};

/**
 * @return {proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.CriteriaCase}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.prototype.getCriteriaCase = function() {
  return /** @type {proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.CriteriaCase} */(jspb.Message.computeOneofCase(this, proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    courseId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pageId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    program: jspb.Message.getFieldWithDefault(msg, 3, 0),
    testOnlyFields: (f = msg.getTestOnlyFields()) && proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest;
  return proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCourseId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageId(value);
      break;
    case 3:
      var value = /** @type {!proto.com.livongo.protobuf.common.user.program.Program.Values} */ (reader.readEnum());
      msg.setProgram(value);
      break;
    case 100:
      var value = new proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields.deserializeBinaryFromReader);
      msg.setTestOnlyFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCourseId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPageId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {!proto.com.livongo.protobuf.common.user.program.Program.Values} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getTestOnlyFields();
  if (f != null) {
    writer.writeMessage(
      100,
      f,
      proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields.toObject = function(includeInstance, msg) {
  var f, obj = {
    timestamp: (f = msg.getTimestamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields;
  return proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimestamp();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp timestamp = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields.prototype.getTimestamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields.prototype.setTimestamp = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields.prototype.clearTimestamp = function() {
  return this.setTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 course_id = 1;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.prototype.getCourseId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.prototype.setCourseId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 page_id = 2;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.prototype.getPageId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.prototype.setPageId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional com.livongo.protobuf.common.user.program.Program.Values program = 3;
 * @return {!proto.com.livongo.protobuf.common.user.program.Program.Values}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.prototype.getProgram = function() {
  return /** @type {!proto.com.livongo.protobuf.common.user.program.Program.Values} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.common.user.program.Program.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.prototype.setProgram = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.prototype.clearProgram = function() {
  return jspb.Message.setOneofField(this, 3, proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.prototype.hasProgram = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional TestOnlyFields test_only_fields = 100;
 * @return {?proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.prototype.getTestOnlyFields = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields, 100));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.TestOnlyFields|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.prototype.setTestOnlyFields = function(value) {
  return jspb.Message.setWrapperField(this, 100, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.prototype.clearTestOnlyFields = function() {
  return this.setTestOnlyFields(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdatePageStatusRequest.prototype.hasTestOnlyFields = function() {
  return jspb.Message.getField(this, 100) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    courseId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pageId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    userAnswers: (f = msg.getUserAnswers()) && proto.com.livongo.protobuf.grpc.external.education.UserAnswers.toObject(includeInstance, f),
    testOnlyFields: (f = msg.getTestOnlyFields()) && proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest;
  return proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCourseId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageId(value);
      break;
    case 3:
      var value = new proto.com.livongo.protobuf.grpc.external.education.UserAnswers;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.education.UserAnswers.deserializeBinaryFromReader);
      msg.setUserAnswers(value);
      break;
    case 100:
      var value = new proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields.deserializeBinaryFromReader);
      msg.setTestOnlyFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCourseId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPageId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getUserAnswers();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.com.livongo.protobuf.grpc.external.education.UserAnswers.serializeBinaryToWriter
    );
  }
  f = message.getTestOnlyFields();
  if (f != null) {
    writer.writeMessage(
      100,
      f,
      proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields.toObject = function(includeInstance, msg) {
  var f, obj = {
    timestamp: (f = msg.getTimestamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields;
  return proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimestamp();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp timestamp = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields.prototype.getTimestamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields.prototype.setTimestamp = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields.prototype.clearTimestamp = function() {
  return this.setTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 course_id = 1;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.prototype.getCourseId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.prototype.setCourseId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 page_id = 2;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.prototype.getPageId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.prototype.setPageId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional UserAnswers user_answers = 3;
 * @return {?proto.com.livongo.protobuf.grpc.external.education.UserAnswers}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.prototype.getUserAnswers = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.education.UserAnswers} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.education.UserAnswers, 3));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.education.UserAnswers|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.prototype.setUserAnswers = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.prototype.clearUserAnswers = function() {
  return this.setUserAnswers(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.prototype.hasUserAnswers = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional TestOnlyFields test_only_fields = 100;
 * @return {?proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.prototype.getTestOnlyFields = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields, 100));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.TestOnlyFields|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.prototype.setTestOnlyFields = function(value) {
  return jspb.Message.setWrapperField(this, 100, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.prototype.clearTestOnlyFields = function() {
  return this.setTestOnlyFields(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.UpdateAnswersRequest.prototype.hasTestOnlyFields = function() {
  return jspb.Message.getField(this, 100) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.TextField.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.TextField.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.TextField} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.TextField.toObject = function(includeInstance, msg) {
  var f, obj = {
    textType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    textValue: jspb.Message.getFieldWithDefault(msg, 2, ""),
    index: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.TextField}
 */
proto.com.livongo.protobuf.grpc.external.education.TextField.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.TextField;
  return proto.com.livongo.protobuf.grpc.external.education.TextField.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.TextField} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.TextField}
 */
proto.com.livongo.protobuf.grpc.external.education.TextField.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.education.TextType.Values} */ (reader.readEnum());
      msg.setTextType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextValue(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIndex(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.TextField.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.TextField.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.TextField} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.TextField.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTextType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTextValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIndex();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional TextType.Values text_type = 1;
 * @return {!proto.com.livongo.protobuf.grpc.external.education.TextType.Values}
 */
proto.com.livongo.protobuf.grpc.external.education.TextField.prototype.getTextType = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.education.TextType.Values} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.education.TextType.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.TextField} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.TextField.prototype.setTextType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string text_value = 2;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.education.TextField.prototype.getTextValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.TextField} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.TextField.prototype.setTextValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 index = 3;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.education.TextField.prototype.getIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.TextField} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.TextField.prototype.setIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.ImageField.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.ImageField.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.ImageField} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.ImageField.toObject = function(includeInstance, msg) {
  var f, obj = {
    imageType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    imageSrc: jspb.Message.getFieldWithDefault(msg, 2, ""),
    width: jspb.Message.getFieldWithDefault(msg, 3, 0),
    height: jspb.Message.getFieldWithDefault(msg, 4, 0),
    index: jspb.Message.getFieldWithDefault(msg, 5, 0),
    description: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ImageField}
 */
proto.com.livongo.protobuf.grpc.external.education.ImageField.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.ImageField;
  return proto.com.livongo.protobuf.grpc.external.education.ImageField.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.ImageField} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ImageField}
 */
proto.com.livongo.protobuf.grpc.external.education.ImageField.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.education.ImageType.Values} */ (reader.readEnum());
      msg.setImageType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageSrc(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidth(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeight(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIndex(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.ImageField.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.ImageField.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.ImageField} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.ImageField.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImageType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getImageSrc();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getIndex();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional ImageType.Values image_type = 1;
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ImageType.Values}
 */
proto.com.livongo.protobuf.grpc.external.education.ImageField.prototype.getImageType = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.education.ImageType.Values} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.education.ImageType.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ImageField} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.ImageField.prototype.setImageType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string image_src = 2;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.education.ImageField.prototype.getImageSrc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ImageField} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.ImageField.prototype.setImageSrc = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 width = 3;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.education.ImageField.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ImageField} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.ImageField.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 height = 4;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.education.ImageField.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ImageField} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.ImageField.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 index = 5;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.education.ImageField.prototype.getIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ImageField} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.ImageField.prototype.setIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string description = 6;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.education.ImageField.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ImageField} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.ImageField.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.Term.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.Term.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.Term} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.Term.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    definition: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Term}
 */
proto.com.livongo.protobuf.grpc.external.education.Term.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.Term;
  return proto.com.livongo.protobuf.grpc.external.education.Term.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.Term} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Term}
 */
proto.com.livongo.protobuf.grpc.external.education.Term.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefinition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.Term.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.Term.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.Term} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.Term.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDefinition();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.education.Term.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Term} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.Term.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string definition = 2;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.education.Term.prototype.getDefinition = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.Term} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.Term.prototype.setDefinition = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonUserData.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.LessonUserData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.LessonUserData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.LessonUserData.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    resumePageId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageUserDataMap: (f = msg.getPageUserDataMap()) ? f.toObject(includeInstance, proto.com.livongo.protobuf.grpc.external.education.PageUserData.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.LessonUserData}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonUserData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.LessonUserData;
  return proto.com.livongo.protobuf.grpc.external.education.LessonUserData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.LessonUserData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.LessonUserData}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonUserData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.education.ContentStatus.Values} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setResumePageId(value);
      break;
    case 3:
      var value = msg.getPageUserDataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readMessage, proto.com.livongo.protobuf.grpc.external.education.PageUserData.deserializeBinaryFromReader, 0, new proto.com.livongo.protobuf.grpc.external.education.PageUserData());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonUserData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.LessonUserData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.LessonUserData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.LessonUserData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getResumePageId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageUserDataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeMessage, proto.com.livongo.protobuf.grpc.external.education.PageUserData.serializeBinaryToWriter);
  }
};


/**
 * optional ContentStatus.Values status = 1;
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ContentStatus.Values}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonUserData.prototype.getStatus = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.education.ContentStatus.Values} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.education.ContentStatus.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.LessonUserData} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.LessonUserData.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 resume_page_id = 2;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonUserData.prototype.getResumePageId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.LessonUserData} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.LessonUserData.prototype.setResumePageId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * map<int32, PageUserData> page_user_data = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.com.livongo.protobuf.grpc.external.education.PageUserData>}
 */
proto.com.livongo.protobuf.grpc.external.education.LessonUserData.prototype.getPageUserDataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.com.livongo.protobuf.grpc.external.education.PageUserData>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      proto.com.livongo.protobuf.grpc.external.education.PageUserData));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.LessonUserData} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.LessonUserData.prototype.clearPageUserDataMap = function() {
  this.getPageUserDataMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.PageUserData.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.PageUserData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.PageUserData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.PageUserData.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    userAnswers: (f = msg.getUserAnswers()) && proto.com.livongo.protobuf.grpc.external.education.UserAnswers.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.PageUserData}
 */
proto.com.livongo.protobuf.grpc.external.education.PageUserData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.PageUserData;
  return proto.com.livongo.protobuf.grpc.external.education.PageUserData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.PageUserData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.PageUserData}
 */
proto.com.livongo.protobuf.grpc.external.education.PageUserData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.education.ContentStatus.Values} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = new proto.com.livongo.protobuf.grpc.external.education.UserAnswers;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.education.UserAnswers.deserializeBinaryFromReader);
      msg.setUserAnswers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.PageUserData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.PageUserData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.PageUserData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.PageUserData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getUserAnswers();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.com.livongo.protobuf.grpc.external.education.UserAnswers.serializeBinaryToWriter
    );
  }
};


/**
 * optional ContentStatus.Values status = 1;
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ContentStatus.Values}
 */
proto.com.livongo.protobuf.grpc.external.education.PageUserData.prototype.getStatus = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.education.ContentStatus.Values} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.education.ContentStatus.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.PageUserData} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.PageUserData.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional UserAnswers user_answers = 2;
 * @return {?proto.com.livongo.protobuf.grpc.external.education.UserAnswers}
 */
proto.com.livongo.protobuf.grpc.external.education.PageUserData.prototype.getUserAnswers = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.education.UserAnswers} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.education.UserAnswers, 2));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.education.UserAnswers|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.PageUserData} returns this
*/
proto.com.livongo.protobuf.grpc.external.education.PageUserData.prototype.setUserAnswers = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.PageUserData} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.PageUserData.prototype.clearUserAnswers = function() {
  return this.setUserAnswers(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.PageUserData.prototype.hasUserAnswers = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.FilterCase = {
  FILTER_NOT_SET: 0,
  PROGRAM: 1
};

/**
 * @return {proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.FilterCase}
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.prototype.getFilterCase = function() {
  return /** @type {proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.FilterCase} */(jspb.Message.computeOneofCase(this, proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    program: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest}
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest;
  return proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest}
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.livongo.protobuf.common.user.program.Program.Values} */ (reader.readEnum());
      msg.setProgram(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.com.livongo.protobuf.common.user.program.Program.Values} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional com.livongo.protobuf.common.user.program.Program.Values program = 1;
 * @return {!proto.com.livongo.protobuf.common.user.program.Program.Values}
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.prototype.getProgram = function() {
  return /** @type {!proto.com.livongo.protobuf.common.user.program.Program.Values} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.common.user.program.Program.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.prototype.setProgram = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.prototype.clearProgram = function() {
  return jspb.Message.setOneofField(this, 1, proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.education.GetEducationSupportLinksRequest.prototype.hasProgram = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.SupportLinks.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.SupportLinks.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.SupportLinks} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.SupportLinks.toObject = function(includeInstance, msg) {
  var f, obj = {
    livongoCoachUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    livongoWebinarUrl: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.SupportLinks}
 */
proto.com.livongo.protobuf.grpc.external.education.SupportLinks.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.SupportLinks;
  return proto.com.livongo.protobuf.grpc.external.education.SupportLinks.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.SupportLinks} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.SupportLinks}
 */
proto.com.livongo.protobuf.grpc.external.education.SupportLinks.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLivongoCoachUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLivongoWebinarUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.SupportLinks.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.SupportLinks.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.SupportLinks} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.SupportLinks.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLivongoCoachUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLivongoWebinarUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string livongo_coach_url = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.education.SupportLinks.prototype.getLivongoCoachUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.SupportLinks} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.SupportLinks.prototype.setLivongoCoachUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string livongo_webinar_url = 2;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.education.SupportLinks.prototype.getLivongoWebinarUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.education.SupportLinks} returns this
 */
proto.com.livongo.protobuf.grpc.external.education.SupportLinks.prototype.setLivongoWebinarUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.ContentStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.ContentStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.ContentStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.ContentStatus.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ContentStatus}
 */
proto.com.livongo.protobuf.grpc.external.education.ContentStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.ContentStatus;
  return proto.com.livongo.protobuf.grpc.external.education.ContentStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.ContentStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ContentStatus}
 */
proto.com.livongo.protobuf.grpc.external.education.ContentStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.ContentStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.ContentStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.ContentStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.ContentStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.education.ContentStatus.Values = {
  INVALID: 0,
  UNSET: 1,
  NOT_YET_AVAILABLE: 2,
  NOT_COMPLETED: 3,
  COMPLETED: 4
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.PageType.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.PageType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.PageType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.PageType.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.PageType}
 */
proto.com.livongo.protobuf.grpc.external.education.PageType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.PageType;
  return proto.com.livongo.protobuf.grpc.external.education.PageType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.PageType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.PageType}
 */
proto.com.livongo.protobuf.grpc.external.education.PageType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.PageType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.PageType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.PageType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.PageType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.education.PageType.Values = {
  INVALID: 0,
  UNSET: 1,
  ICON_PAGE: 2,
  TIP_PAGE: 3,
  IMAGE_PAGE: 4,
  QUESTION_PAGE: 5
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.ImageType.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.ImageType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.ImageType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.ImageType.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ImageType}
 */
proto.com.livongo.protobuf.grpc.external.education.ImageType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.ImageType;
  return proto.com.livongo.protobuf.grpc.external.education.ImageType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.ImageType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.ImageType}
 */
proto.com.livongo.protobuf.grpc.external.education.ImageType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.ImageType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.ImageType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.ImageType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.ImageType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.education.ImageType.Values = {
  INVALID: 0,
  UNSET: 1,
  ICON_IMAGE: 2,
  POSTER_IMAGE: 3,
  HERO_IMAGE: 4,
  THUMBNAIL_IMAGE: 5,
  TITLE_IMAGE: 6
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.education.TextType.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.education.TextType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.education.TextType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.TextType.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.TextType}
 */
proto.com.livongo.protobuf.grpc.external.education.TextType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.education.TextType;
  return proto.com.livongo.protobuf.grpc.external.education.TextType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.TextType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.education.TextType}
 */
proto.com.livongo.protobuf.grpc.external.education.TextType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.education.TextType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.education.TextType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.education.TextType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.education.TextType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.education.TextType.Values = {
  INVALID: 0,
  UNSET: 1,
  TITLE: 2,
  SUBTITLE: 3,
  DESCRIPTION: 4,
  BEGIN_CAPTION: 5,
  FINISH_CAPTION: 6,
  COMPLETED_MESSAGE: 7,
  BODY: 8,
  TIP_TEXT: 9,
  QUESTION_IDENTIFIER: 10,
  QUESTION: 11,
  OTHER_ANSWER: 12,
  OTHER_PLACEHOLDER: 13,
  ACKNOWLEDGEMENT: 14,
  NAME: 15,
  DEFINITION: 16,
  URL: 17,
  WIDTH: 18,
  HEIGHT: 19,
  CONTENT_TYPE: 20,
  TIP_TYPE: 21,
  INCLUDE_OTHER: 22,
  CADENCE_SKIP: 23,
  LAST_REQUIRED_PAGE_INDEX: 24,
  ANSWER_TEXT: 25
};

goog.object.extend(exports, proto.com.livongo.protobuf.grpc.external.education);
